<template>
  <div>
    <!-- HEADER -->
    <div class="form-header">
      <div class="form-header-left">
        <button class="back-circle-btn" @click="Closepage('/kirim/index')"><b-icon icon="chevron-left"></b-icon></button>
        <h2 class="page-title">{{ $t($route.name) }} <span v-if="$route.params.id != undefined">&#8470;{{ $route.params.id }}</span></h2>
        <button v-if="$route.params.id!=undefined && settedrule.change==true" class="change-btn" @click="Change()">{{$t('Ўзгартириш')}}</button>
      </div>
      <div class="form-header-right">
        <label>Курс</label>
        <input :disabled="changedisabled" type="text" v-model="datas.dollar_rate" class="kurs-input">
      </div>
    </div>

    <!-- TOP FORM BAR -->
    <div class="form-fields-bar">
      <div class="field-item">
        <label>Факт №</label>
        <input :disabled="changedisabled" type="number" class="input100" v-model="datas.number">
      </div>
      <div class="field-item">
        <label>{{$t('Вақт')}}</label>
        <input type="datetime-local" disabled="true" class="input100" :value="SetDatetime(datas.created_at)">
      </div>
      <div class="field-item" style="min-width: 160px;">
        <label>Склад</label>
        <v-select :disabled="skladhave" :clearable="false" class="form-control-sm required md-input"
          :options="skladlist" v-model="datas.sklad_id" :reduce="name => name.id" label="name">
          <template #search="{ attributes, events }">
            <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
              <b>insert</b>
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="field-item" style="min-width: 180px;">
        <label>{{ $t("Етказувчи") }}</label>
        <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input" :options="supplierlist"
          v-model="datas.kontragent_id" :reduce="name => name.id" label="name">
          <template #list-footer>
            <li style="text-align: center;font-weight:bold; cursor: pointer;" @click="OpenTaminotchiList()">
              {{ $t("Ta'minotchilar bo'limi") }}
            </li>
          </template>
          <template #search="{ attributes, events }">
            <input class="vs__search" ref="focused" v-bind="attributes" v-on="events" />
            <button type="button" :disabled="changedisabled" class="modallist" @click="OpenTaminotchiList()">
              <b-icon icon="three-dots"></b-icon>
            </button>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
              <button :disabled="changedisabled" type="button" class="pluss" @click="CreateTaminotchi(search)">
                +
              </button>
              <b>insert</b>
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="field-item" style="min-width: 160px;">
        <label>{{ $t("Тўлов тури") }}</label>
        <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input" :options="paytypelist"
          v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
          <template #list-footer>
            <li style="text-align: center;font-weight:bold;">
              f4 {{ $t("умумий рўйхат") }}
            </li>
          </template>
          <template #search="{ attributes, events }">
            <input class="vs__search" v-bind="attributes" v-on="events" />
            <button :disabled="changedisabled" type="button" class="modallist" v-b-modal.modal-paytypelist>
              <b-icon icon="three-dots"></b-icon>
            </button>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="field-item">
        <label>Расход</label>
        <input :disabled="changedisabled" type="text" v-model.number="datas.rasxod_summa" class="needt input100" @input="RasxodXisob()" />
      </div>
      <div class="field-item">
        <label>Скидка</label>
        <input :disabled="changedisabled" type="text" v-model="datas.skidka_summa" class="needt input100" />
      </div>
    </div>

    <!-- PRODUCTS: CARD GRID -->
    <div class="cards-section">
      <!-- Totals strip -->
      <div class="cards-totals">
        <button :disabled="changedisabled" class="add-product-top" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon> {{ $t("Маҳсулот қўшиш") }} <sup>F1</sup>
        </button>
        <div class="ct-pill"><small>JAMI DONA</small><b>{{ datas.count_all | numFormat }}</b></div>
        <div class="ct-pill blue"><small>OBSH SUMMA</small><b>{{ datas.summa | numFormat }}</b></div>
        <div class="ct-pill"><small>SEBES. (KIRIM) SUMMA</small><b>{{ datas.prixod_summa | numFormat }}</b></div>
        <div class="ct-count">{{ datas.prixod_table.length }} ta mahsulot</div>
      </div>

      <div class="cards-wrap">
        <div class="prod-card" v-for="(item, index) in datas.prixod_table" :key="index">
          <!-- HEAD: № + barcode + delete -->
          <div class="pc-head">
            <span class="pc-index" v-if="settings[0].view==true">{{ index + 1 }}</span>
            <div class="pc-barcode" v-if="settings[1].view==true">
              <b-icon icon="upc-scan"></b-icon>
              <input :disabled="changedisabled" class="table-input pc-bc" type="text" v-model="item.shtrix_kod"
                @change="Shtrix(index)" placeholder="Shtrix kod" />
            </div>
            <a v-if="changedisabled==false" href="javascript:void(0)" class="pc-del" @click="Trashitem(index)" :title="$t('Ўчириш')">
              <b-icon icon="trash"></b-icon>
            </a>
          </div>

          <!-- PRODUCT SELECT -->
          <div class="pc-product" v-if="settings[2].view==true">
            <v-select style="width: 100%;" :disabled="changedisabled" v-if="productlist != null" :filter-by="$store.state.myFilter" :clearable="false"
              class="form-control-sm required" @search="query => (search = query)" :options="paginated"
              menu-props="auto" v-model="item.product_id" :reduce="extra_name => extra_name.id" label="extra_name"
              @input="Productchange(index)">
              <template #list-footer>
                <li style="text-align: center;font-weight:bold;">
                  f4 {{ $t("умумий рўйхат") }}
                </li>
              </template>
              <template #selected-option-container="{option}">
                <div class="vs__selected">
                  <span v-if="typeof option.extra_name === 'number'">{{
                    Label(option.extra_name)
                    }}</span><span v-else>{{ option.extra_name }}</span>
                </div>
              </template>
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes"></span>
                <button :disabled="changedisabled" type="button" class="modallist" @click="Selectproduct(index)">
                  <b-icon icon="three-dots"></b-icon>
                </button>
              </template>
              <template #selected-option="{ extra_name }">
                <div style="position: absolute">
                  {{ extra_name }}
                </div>
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  {{ $t("бўйича маьлумот йўқ") }}
                  <button type="button" class="pluss" @click="CreateProduct(index, search)">
                    +</button><b>Insert</b>
                </template>
                <em style="opacity: 0.5" v-else>{{
                  $t("Маьлумот йўқ")
                  }}</em>
              </template>
              <template #search="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                </template>
              </template>
            </v-select>
          </div>

          <!-- BALANCE -->
          <div class="pc-balance" v-if="settings[3].view==true">
            <b-icon icon="box-seam"></b-icon> {{ $t("Қолдиқ") }}: <b>{{ item.current_balance | numFormat0 }}</b>
          </div>

          <!-- MIQDOR / СОНИ — Пачка сони × Пачкада = Жами дона -->
          <div class="pc-group">
            <div class="pc-group-title g-kolvo"><b-icon icon="box-seam"></b-icon> {{$t('Кол-во')}}</div>
            <div class="pc-qty">
              <label class="pc-field" v-if="settings[16].view==true">
                <span>{{$t(settings[16].column)}}</span>
                <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="0" v-model="item.pack_count"
                  class="table-input" @input="item.pack_count = $event; Changepack(index)"></vue-numeric>
              </label>
              <span class="pc-op" v-if="settings[16].view==true && settings[18].view==true">×</span>
              <label class="pc-field" v-if="settings[18].view==true">
                <span>{{ $t(settings[18].column) }}</span>
                <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="0" v-model="item.pack_norma"
                  class="table-input" @input="item.pack_norma = $event; Changenorma(index)"></vue-numeric>
              </label>
              <span class="pc-op" v-if="settings[4].view==true">=</span>
              <label class="pc-field pc-field-total" v-if="settings[4].view==true">
                <span>{{ $t("Штук") }}</span>
                <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="0" v-model="item.count"
                  class="table-input" @input="item.count = $event; Changecount(index)"></vue-numeric>
              </label>
            </div>
          </div>

          <!-- KIRIM NARXI -->
          <div class="pc-group">
            <div class="pc-group-title g-kirim"><b-icon icon="cash-stack"></b-icon> {{$t('Нарх')}} ({{$t('Обш')}})</div>
            <div class="pc-fields">
              <label class="pc-field" v-if="settings[17].view==true">
                <span>{{$t(settings[17].column)}}</span>
                <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="3"
                  v-model="item.pack_price" class="table-input" @change="Changepackprice(index)"></vue-numeric>
              </label>
              <label class="pc-field" v-if="settings[5].view==true">
                <span>{{ $t("Нарх") }}</span>
                <div class="pc-price-wrap">
                  <button type="button" class="cur-toggle" :class="{ 'cur-dollar': Number(item.price_type) === 2 }"
                    :disabled="changedisabled"
                    :title="Number(item.price_type) === 2 ? 'Dollarda — bosing soʼm qilish' : 'Soʼmda — bosing dollar qilish'"
                    @click="toggleItemCurrency(index)">
                    {{ Number(item.price_type) === 2 ? '$' : 'soʼm' }}
                  </button>
                  <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="3"
                    :style="{ color: Number(item.price_type) === 2 ? '#16a34a' : '' }"
                    v-model="item.kontragent_price" class="table-input" @change="Changeprice(index)"></vue-numeric>
                </div>
              </label>
            </div>
            <!-- Hisoblangan qiymatlar (read-only) -->
            <div class="pc-summary">
              <div class="pcs-item" v-if="settings[7].view==true">
                <span>{{ $t("Себес.") }}</span>
                <b>{{ item.debit_price | numFormat3 }}</b>
              </div>
              <div class="pcs-item" v-if="settings[6].view==true">
                <span>{{$t('Обш')}} сумма</span>
                <b class="blue">{{ item.kontragent_summa | numFormat }}</b>
              </div>
              <div class="pcs-item" v-if="settings[8].view==true">
                <span>{{ $t("Себес.") }} сумма</span>
                <b>{{ item.debit_summa | numFormat }}</b>
              </div>
            </div>
          </div>

          <!-- SOTUV NARXLARI — ikki ustun: Чакана / Улгуржи -->
          <div class="pc-group">
            <div class="pc-group-title g-sena"><b-icon icon="tag"></b-icon> {{ $t("Чакана") }} / {{ $t("Улгуржи") }}</div>
            <div class="pc-sell">
              <!-- ЧАКАНА -->
              <div class="pc-sell-col">
                <div class="pc-sell-head chakana-h">{{ $t("Чакана") }}</div>
                <label class="pc-field" v-if="settings[9].view==true">
                  <span>%</span>
                  <input type="number" :disabled="changedisabled" v-model="item.chakana_percent"
                    class="table-input" @input="Changepercentchakana(index)" @change="AutoRoundChakana(index)">
                </label>
                <label class="pc-field" v-if="settings[10].view==true">
                  <span>сўм</span>
                  <div class="pc-round-wrap">
                    <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="2"
                      v-model="item.chakana_price" class="table-input" @change="Changepricechakana(index)"></vue-numeric>
                    <span class="round-btns">
                      <button type="button" class="round-btn" :disabled="changedisabled"
                        :title="'+' + roundStep" @click="RoundChakana(index, 'up')">▲</button>
                      <button type="button" class="round-btn" :disabled="changedisabled"
                        :title="'−' + roundStep" @click="RoundChakana(index, 'down')">▼</button>
                    </span>
                  </div>
                </label>
                <label class="pc-field" v-if="settings[11].view==true">
                  <span>$</span>
                  <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="3" style="color:#16a34a"
                    v-model="item.chakana_dollar_price" class="table-input" @change="Changepricechakanadollar(index)"></vue-numeric>
                </label>
              </div>
              <!-- УЛГУРЖИ -->
              <div class="pc-sell-col">
                <div class="pc-sell-head optom-h">{{ $t("Улгуржи") }}</div>
                <label class="pc-field" v-if="settings[12].view==true">
                  <span>%</span>
                  <input type="number" :disabled="changedisabled" v-model="item.optom_percent"
                    class="table-input" @input="Changepercentoptom(index)" @change="AutoRoundOptom(index)">
                </label>
                <label class="pc-field" v-if="settings[13].view==true">
                  <span>сўм</span>
                  <div class="pc-round-wrap">
                    <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="2"
                      v-model="item.optom_price" class="table-input" @change="Changepriceoptom(index)"></vue-numeric>
                    <span class="round-btns">
                      <button type="button" class="round-btn" :disabled="changedisabled"
                        :title="'+' + roundStep" @click="RoundOptom(index, 'up')">▲</button>
                      <button type="button" class="round-btn" :disabled="changedisabled"
                        :title="'−' + roundStep" @click="RoundOptom(index, 'down')">▼</button>
                    </span>
                  </div>
                </label>
                <label class="pc-field" v-if="settings[14].view==true">
                  <span>$</span>
                  <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="3" style="color:#16a34a"
                    v-model="item.optom_dollar_price" class="table-input" @change="Changepriceoptomdollar(index)"></vue-numeric>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- EMPTY STATE -->
        <div v-if="datas.prixod_table.length === 0" class="cards-empty">
          {{ $t("Маьлумот йўқ") }} — <b>F1</b> yoki "+" tugmasi orqali mahsulot qo'shing.
        </div>
      </div>
    </div>

    <!-- BOTTOM BAR -->
    <div class="form-footer">
      <!-- Currency totals: SO'M vs DOLLAR -->
      <div class="cur-totals">
        <div class="cur-total-pill som">
          <small>SO'M JAMI</small>
          <b>{{ (datas.summa_som || 0) | numFormat }} so'm</b>
        </div>
        <div class="cur-total-pill dollar">
          <small>DOLLAR JAMI</small>
          <b>$ {{ (datas.summa_dollar || 0) | numFormat }}</b>
        </div>
        <div class="cur-total-pill total">
          <small>JAMI (so'm ekv.)</small>
          <b>{{ (datas.summa || 0) | numFormat }}</b>
        </div>
      </div>

      <!-- Sotuv narxini yaxlitlash sozlamalari -->
      <div class="round-settings">
        <label class="rs-check" :title="$t('Foiz kiritilganda narx eng yaqin qadamga yaxlitlanadi')">
          <input type="checkbox" :disabled="changedisabled" v-model="autoRound">
          Avto-yaxlitlash
        </label>
        <label class="rs-step">
          Qadam
          <input type="number" :disabled="changedisabled" v-model.number="roundStep"
            min="0" step="100" class="rs-step-input">
        </label>
      </div>

      <div style="display: flex; align-items: center; gap: 8px;">
        <label style="white-space: nowrap; font-weight: 600; color: #64748b;">Комментарий</label>
        <textarea :disabled="changedisabled" rows="1" v-model="datas.comment" class="needt form-control" type="text"></textarea>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
        <button :disabled="changedisabled" class="footer-btn add-row-btn" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button :disabled="changedisabled" type="button" class="footer-btn" v-b-modal.modal-settings>
          <b-icon icon="gear"></b-icon>
        </button>
        <span v-if="changedisabled==false">
        <button :disabled="sending" class="footer-btn" type="button" href="javascript:void(0)" @click="RasxodXisob()">Расход</button>
        <button class="footer-btn" type="button" @click="downloadExl()">
          <b-icon icon="cloud-download"></b-icon> Excel
        </button>
        <button :disabled="sending" class="footer-btn" id="chek" type="button" @click="Savedokument('a4')">
          <b-icon icon="printer"></b-icon> A4
        </button>
        <button :disabled="sending" class="footer-btn" id="chek" type="button" @click="Savedokument('print')">
          <b-icon icon="printer"></b-icon> Чек<sup>F7</sup>
        </button>
        <button :disabled="sending" class="footer-btn" id="chek" type="button" @click="Savedokument('barcode')">
          <b-icon icon="upc-scan"></b-icon><sup></sup>
        </button>
        <button :disabled="sending" class="btn-save" type="button" @click="Savedokument('save')">
          {{ $t("Сақлаш") }}
        </button>
        <button  :disabled="sending" class="btn-save-close" type="button" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }}<sup>crl+enter</sup>
        </button>
        </span>
      </div>
    </div>

    <!-- SETTINGS MODAL -->
    <b-modal id="modal-settings" hide-footer size="xl" @shown="Shoved" @hidden="SaveSettings()">
      <div class="modal-table-wrapper">
        <table class="modal-table">
          <thead>
            <th>{{$t('Номи')}}</th>
            <th>{{$t('Кўрсатиш')}}</th>
            <th>{{$t('Ўлчами')}}</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in settings" :key="index">
              <td>{{$t(item.column)}}</td>
              <td>
                <input type="checkbox" v-model="item.view">
              </td>
              <td>
                <input type="number" v-model="item.width">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <!-- SHTRIX MODAL -->
    <b-modal id="modal-shtrix" title="Товар" hide-footer size="xl" @shown="Shoved" @hidden="Hide()">
      <div class="modal-table-wrapper">
        <div class="search-wrapper">
          <input type="text" class="form-control searchtable" v-bind:placeholder="$t('Қидирув')" v-model="filter"
            ref="inputText2" />
        </div>
        <table class="modal-table">
          <thead>
            <tr>
              <th>&#8470;</th>
              <th>{{ $t("Номи") }}</th>
              <th>{{ $t("Қолдиқ") }}</th>
              <th>{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
              <th>{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
              <th>Штрих</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in filteredRows" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                <button type="button" class="atable" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    ">
                  {{ item.extra_name }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    ">
                  {{ item.balance }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.price_register[0]">
                  {{ item.price_register[0].chakana_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.price_register[0]">
                  {{ item.price_register[0].optom_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.shtrix_table[0]">
                  {{ item.shtrix_table[0].shtrix_kod }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <!-- TEZ MAHSULOT QO'SHISH MODALI -->
    <b-modal id="modal-quick-product" :title="$t('Янги маҳсулот қўшиш')" hide-footer centered size="lg"
      @shown="$nextTick(() => { if ($refs.quickName) $refs.quickName.focus(); })">
      <div class="quick-form">
        <!-- Nomi (to'liq kenglik) -->
        <div class="qf-field qf-full">
          <label>{{ $t('Номи') }} <span class="qf-req">*</span></label>
          <input ref="quickName" type="text" v-model="quickProduct.name" class="qf-input"
            :placeholder="$t('Маҳсулот номи')" @keyup.enter="saveQuickProduct" />
        </div>

        <div class="qf-grid">
          <div class="qf-field">
            <label>Штрих код</label>
            <input type="text" v-model="quickProduct.shtrix_kod" class="qf-input" placeholder="Shtrix kod" />
          </div>
          <div class="qf-field">
            <label>{{ $t("Eд.изм.") }}</label>
            <v-select class="qf-select" :options="quickUnits" v-model="quickProduct.unit_id"
              :reduce="o => o.id" label="name" :placeholder="$t('Маьлумот йўқ')"></v-select>
          </div>
          <div class="qf-field">
            <label>Brend</label>
            <v-select class="qf-select" :options="quickBrands" v-model="quickProduct.brand_id"
              :reduce="o => o.id" label="name" :placeholder="$t('Маьлумот йўқ')"></v-select>
          </div>
          <div class="qf-field">
            <label>Model</label>
            <v-select class="qf-select" :options="quickModels" v-model="quickProduct.model_id"
              :reduce="o => o.id" label="name" :placeholder="$t('Маьлумот йўқ')"></v-select>
          </div>
          <div class="qf-field">
            <label>{{ $t('Рангги') }}</label>
            <v-select class="qf-select" :options="quickColours" v-model="quickProduct.colour_id"
              :reduce="o => o.id" label="name" :placeholder="$t('Маьлумот йўқ')"></v-select>
          </div>
          <div class="qf-field">
            <label>{{ $t('Сифати') }}</label>
            <input type="text" v-model="quickProduct.quality" class="qf-input" placeholder="—" />
          </div>
          <div class="qf-field">
            <label>{{ $t('Мин. миқдор') }}</label>
            <input type="number" v-model.number="quickProduct.minimum_amount" class="qf-input" min="0" />
          </div>
        </div>

        <div class="qf-hint">
          <b-icon icon="info-circle"></b-icon>
          {{ $t("Mahsulot bazaga qo'shilib, shu qatorga avtomatik tanlanadi") }}
        </div>
        <div class="qf-actions">
          <button type="button" class="qf-cancel" @click="$bvModal.hide('modal-quick-product')">
            {{ $t('Отмена') }}
          </button>
          <button type="button" class="qf-save" :disabled="quickSaving" @click="saveQuickProduct">
            {{ quickSaving ? $t('Сақланмоқда...') : $t('Сақлаш') }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { print } from "../../components/mixins/print.js";
  import $ from "jquery";
  var XLSX = require("xlsx");
  var FileSaver = require("file-saver");
  export default {
    name: "KirimForm",
    mixins: [print],
    data() {
      return {
        settings: [
          { 'column': '№', 'width': 70, 'view': true },
          { 'column': 'shtrix_kod', 'width': 120, 'view': true },
          { 'column': 'product_id', 'width': 300, 'view': true },
          { 'column': 'current_balance', 'width': 100, 'view': true },
          { 'column': 'count', 'width': 100, 'view': true },
          { 'column': 'kontragent_price', 'width': 100, 'view': true },
          { 'column': 'kontragent_summa', 'width': 120, 'view': true },
          { 'column': 'debit_price', 'width': 100, 'view': true },
          { 'column': 'debit_summa', 'width': 120, 'view': true },
          { 'column': 'chakana_percent', 'width': 100, 'view': true },
          { 'column': 'chakana_price', 'width': 100, 'view': true },
          { 'column': 'chakana_dollar_price', 'width': 100, 'view': true },
          { 'column': 'optom_percent', 'width': 100, 'view': true },
          { 'column': 'optom_price', 'width': 100, 'view': true },
          { 'column': 'optom_dollar_price', 'width': 100, 'view': true },
          { 'column': 'del', 'width': 70, 'view': true },
          { 'column': 'pack_count', 'width': 100, 'view': true },
          { 'column': 'pack_price', 'width': 100, 'view': true },
          { 'column': 'pack_norma', 'width': 90, 'view': true }
        ],
        kontragent: "",
        shtrixlist: [],
        settedindex: null,
        sklad: "",
        paytype: "",
        filter: "",
        focusset: "",
        kontragentlist: [],
        skladlist: [],
        paytypelist: [],
        // Sotuv narxini "chiroyli" songa yaxlitlash qadami (so'm)
        roundStep: 1000,
        // Foiz kiritilganda narxni avtomatik yaxlitlab, foizni qayta hisoblash
        autoRound: true,
        // Tez (inline) yangi mahsulot qo'shish modali
        quickProduct: {
          index: null, name: '', shtrix_kod: '', pack_norma: 1,
          unit_id: null, brand_id: null, model_id: null, colour_id: null,
          quality: '', minimum_amount: 1,
        },
        quickSaving: false,
        quickListsLoaded: false,
        quickUnits: [],
        quickBrands: [],
        quickModels: [],
        quickColours: []
      };
    },
    props: ["datas"],
    watch: {
      // Mavjud kirim hujjati tahrirlash uchun ochilganda (Update.vue datas'ni
      // to'liq almashtiradi) har bir qatorning joriy omborda qancha qolgani
      // backenddan olinmagani uchun "Қолдиқ" doim 0 ko'rinardi — endi shu yerda tortib olamiz.
      'datas.prixod_table'(newTable, oldTable) {
        if (Array.isArray(newTable) && newTable.length && newTable !== oldTable) {
          this.FetchBalances();
        }
      }
    },
    created: function () {
      let self = this;
      self.$root.$refs.prixod = self;
      self.$root.$on("kontragentone", function (getdata) {
        self.kontragent = getdata;
      });
      self.$root.$on("kontragentall", function (getdata) {
        self.kontragentlist = getdata;
      });
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          this.Productlist();
          this.datas.prixod_table[
            this.$store.state.selected_index
          ].product_id = parseInt(localStorage.getItem("setted_product"));
          if (this.$store.state.selected_index != null) {
            this.Productchange(this.$store.state.selected_index);
          }
          localStorage.setItem("setted_product", 0);
          setTimeout(() => {
            this.Next();
          }, 1000);
        }
      }),
        setTimeout(() => {
          localStorage.setItem("sklad_id_dok", this.datas.sklad_id);
          localStorage.setItem("created_at_dok", this.datas.created_at);
        }, 1000);
    },
    mounted: function () {
      // this.datas.created_at=this.SetDatetime(this.datas.created_at);
      setTimeout(() => {
        this.Focus();
        this.SetRule('/kirim/index');
      }, 100);
      this.Settings();
      // Ta'minotchi oynasidan qaytganda ro'yxatni yangilab, yangi qo'shilganini tanlash mumkin bo'lsin
      window.addEventListener("focus", this.RefreshKontragents);
    },
    beforeDestroy: function () {
      window.removeEventListener("focus", this.RefreshKontragents);
    },
    methods: {
      // Mavjud hujjat tahrirlashda ochilgan qatorlar uchun joriy ombor qoldig'ini
      // tortib olib "Қолдиқ" maydonini to'ldiradi (narxlarga tegmaydi).
      FetchBalances() {
        let self = this;
        (self.datas.prixod_table || []).forEach(function (item) {
          if (item.product_id > 0) {
            axios({
              method: "post",
              url: "api/v1/product/price-balance",
              data: { product_id: item.product_id, sklad_id: self.datas.sklad_id }
            }).then(function (response) {
              self.$set(item, 'current_balance', response.data.balance);
            });
          }
        });
      },
      // Excel eksport — DOM jadvalga emas, to'g'ridan-to'g'ri ma'lumotga asoslanadi
      // (kartochka ko'rinishida ham ishonchli ishlaydi). Mahsulot nomi Label() orqali olinadi.
      downloadExl() {
        const num = v => Number(v) || 0;
        const header = [
          '№', 'Штрих', 'Номи', 'Қолдиқ', '1 пачкада', 'Пачка', 'Штук', 'Пачка нарх',
          'Дона нарх', 'Валюта', 'Себес.', 'Обш сумма', 'Себес сумма',
          'Чакана %', 'Улгуржи %', 'Чакана сўм', 'Чакана $', 'Улгуржи сўм', 'Улгуржи $'
        ];
        const rows = (this.datas.prixod_table || []).map((it, i) => [
          i + 1,
          it.shtrix_kod || '',
          (this.Label ? this.Label(it.product_id) : it.product_id) || '',
          num(it.current_balance),
          num(it.pack_norma),
          num(it.pack_count),
          num(it.count),
          num(it.pack_price),
          num(it.kontragent_price),
          Number(it.price_type) === 2 ? '$' : "so'm",
          num(it.debit_price),
          num(it.kontragent_summa),
          num(it.debit_summa),
          num(it.chakana_percent),
          num(it.optom_percent),
          num(it.chakana_price),
          num(it.chakana_dollar_price),
          num(it.optom_price),
          num(it.optom_dollar_price),
        ]);
        // JAMI qatori
        rows.push([
          '', '', 'JAMI', '', '', '', num(this.datas.count_all), '', '', '', '',
          num(this.datas.summa), num(this.datas.prixod_summa), '', '', '', '', '', ''
        ]);
        const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);
        ws['!cols'] = header.map((_, i) => ({ width: i === 2 ? 28 : 13 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
        FileSaver.saveAs(
          new Blob([this.s2ab(wbout)], { type: 'application/octet-stream;charset=utf-8' }),
          new Date() + '.xlsx'
        );
      },
      // Mixin'dagi Tablefocus jadval (<tbody><tr>) ga tayanardi — kartochka uchun override.
      // Yangi qator qo'shilgach oxirgi kartaning birinchi inputiga fokus beradi.
      Tablefocus() {
        // Yangi qo'shilgan karta grid'da yonidagi joyga tushadi; uni silliq
        // ko'rinishga keltiramiz (eng pastga sakramasdan) va birinchi inputiga fokus beramiz.
        this.$nextTick(() => {
          setTimeout(() => {
            const cards = document.querySelectorAll('.prod-card');
            const last = cards[cards.length - 1];
            if (!last) return;
            last.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            const inp = last.querySelector('.table-input');
            if (inp) {
              // preventScroll — fokus o'zicha sakratib yubormasligi uchun (smooth scroll qoladi)
              try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); }
            }
          }, 120);
        });
      },
      Settings() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'prixod' }
        }).then(function (response) {
          if (response.data.data == null) {
            self.SaveSettings();
          } else {
            var value=JSON.parse(response.data.data);
            if(value.length<self.settings.length){
              for (let index = value.length; index < self.settings.length; index++) {
                value.push(self.settings[index]);
              }
            }
            self.settings = value;
          }
        });
      },
      SaveSettings() {
        let self = this;
        let stringsettings = JSON.stringify(self.settings);
        axios({
          method: "patch",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'prixod', data: stringsettings }
        }).then(function (response) {
        });
      },
      // Bazada yo'q mahsulotni shu sahifaning o'zida (yangi oynasiz) tez qo'shish
      CreateProduct(index, search) {
        this.quickProduct = {
          index,
          name: (search || '').trim(),
          shtrix_kod: this.datas.prixod_table[index].shtrix_kod || '',
          pack_norma: this.datas.prixod_table[index].pack_norma || 1,
          unit_id: null, brand_id: null, model_id: null, colour_id: null,
          quality: '', minimum_amount: 1,
        };
        this.loadQuickLists();
        this.$bvModal.show('modal-quick-product');
      },
      // Modal uchun ro'yxatlarni (faqat bir marta) yuklash
      loadQuickLists() {
        if (this.quickListsLoaded) return;
        this.quickListsLoaded = true;
        const grab = (url, key) => axios.get(url)
          .then(r => { this[key] = Array.isArray(r.data) ? r.data : []; })
          .catch(() => { this[key] = []; });
        grab('api/v1/unit', 'quickUnits');
        grab('api/v1/brand', 'quickBrands');
        grab('api/v1/model', 'quickModels');
        grab('api/v1/colour', 'quickColours');
      },
      // Tez modaldan yangi mahsulotni saqlash, ro'yxatga qo'shish va qatorga biriktirish
      async saveQuickProduct() {
        if (this.quickSaving) return;
        const name = (this.quickProduct.name || '').trim();
        if (name.length < 3) {
          this.$store.state.errors = this.$t("Nomi kamida 3 ta belgidan iborat bo'lsin");
          return;
        }
        this.quickSaving = true;
        try {
          let number = 0;
          try {
            const nr = await axios.get('api/v1/product/last-number');
            number = (nr.data && (nr.data.number || nr.data)) || 0;
          } catch (e) { /* raqam topilmasa 0 */ }

          const fd = new FormData();
          fd.append('see', true);
          fd.append('name', name);
          fd.append('extra_name', name);
          fd.append('quality', this.quickProduct.quality || '');
          fd.append('is_folder', 0);
          fd.append('parent_id', 0);
          fd.append('minimum_amount', this.quickProduct.minimum_amount || 1);
          fd.append('pack_count', this.quickProduct.pack_norma || 1);
          fd.append('number', number);
          fd.append('unit_id', this.quickProduct.unit_id || 0);
          fd.append('colour_id', this.quickProduct.colour_id || 0);
          fd.append('country_id', 0);
          fd.append('model_id', this.quickProduct.model_id || 0);
          fd.append('brand_id', this.quickProduct.brand_id || 0);
          fd.append('extra_unit_id1', 0);
          fd.append('extra_unit_id2', 0);
          fd.append('shtrix_table[0][shtrix_kod]', this.quickProduct.shtrix_kod || '');

          const res = await axios({ method: 'post', url: 'api/v1/product', data: fd });
          const p = res.data || {};
          // v-select darhol ko'rsatishi uchun ro'yxat boshiga qo'shamiz
          if (Array.isArray(this.productlist)) {
            this.productlist.unshift({
              id: p.id,
              extra_name: p.extra_name || name,
              name: p.name || name,
              is_folder: p.is_folder || 0,
              parent_id: p.parent_id || 0,
              shtrix_table: [],
              price_register: [],
            });
          }
          // Joriy qatorga biriktirish
          const idx = this.quickProduct.index;
          if (idx != null && this.datas.prixod_table[idx]) {
            this.datas.prixod_table[idx].product_id = p.id;
            if (this.quickProduct.shtrix_kod) {
              this.datas.prixod_table[idx].shtrix_kod = this.quickProduct.shtrix_kod;
            }
            this.Productchange(idx);
          }
          this.$bvModal.hide('modal-quick-product');
        } catch (e) {
          console.error("Mahsulot qo'shishda xato:", e);
          this.$store.state.errors = (e.response && e.response.data && (e.response.data.message || e.response.data))
            || this.$t('Xatolik yuz berdi');
        } finally {
          this.quickSaving = false;
        }
      },
      handlerClose: function (event) {
        if (this.$store.state.saved == null) {
          this.$store.state.saved = null;
        } else {
          const answer = window.confirm(
            this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
          );
          if (answer) {
            this.Savedokument();
            event.returnValue = "";
          } else {
            this.$store.state.saved = null;
          }
        }
      },
      Autoadd(index) {
        if (this.datas.prixod_table.length == index + 1) {
          this.Addtable('focusnot');
        }
      },
      Shoved() {
        let self = this;
        $(document).on("focusout", function (e) {
          if ($(e.target).attr("class") == "vs__search") {
            if (self.focusset == "") {
              self.focusset = e.target;
            }
          }
        });
        self.$refs.inputText2.focus();
      },
      Hide() {
        let self = this;
        setTimeout(function (e) {
          var classs = $(":focus");
          var rrr = $("body")
            .find("input,select,textarea,button")
            .filter(":visible");
          if (classs.attr("class") == "vs__search") {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              var focused = rrr.eq(rrr.index(classs) + 2);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          } else if (classs.attr("class") == undefined) {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              focused = rrr.eq(rrr.index($(self.focusset)) + 3);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          }
        }, 100);
      },
      Trashitem(index) {
        const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
        if (answer) {
          this.datas.summa -= this.datas.prixod_table[index].kontragent_summa;
          this.datas.prixod_summa -= this.datas.prixod_table[index].debit_summa;
          this.datas.count_all -= this.datas.prixod_table[index].count;
          this.datas.prixod_table.splice(index, 1);
        }
      },
      Productchange(index) {
        if(this.changedisabled==false){
        let self = this;
        var item = self.datas.prixod_table[index];
        item.optom_price = 0;
        item.chakana_price = 0;
        axios({
          method: "post",
          url: "api/v1/product/price-balance",
          data: { product_id: item.product_id, sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          if (self.datas.pay_type_id == 3) {
            item.current_balance = response.data.balance;
            if (response.data.price_type == 2) {
              item.kontragent_price = response.data.delivery_price;
              item.pack_price=item.pack_norma*response.data.delivery_price;
              item.debit_price = response.data.delivery_price;
            } else if (response.data.price_type == 1) {
              item.kontragent_price = response.data.delivery_price/self.datas.dollar_rate;
              item.pack_price=item.pack_norma*response.data.delivery_price/self.datas.dollar_rate;
              item.debit_price = response.data.delivery_price/self.datas.dollar_rate;
              window.alert(
                self.$t("Bu tovar avval boshqa valutada kelgan")
              );
            }
            if (response.data.optom_dollar_price) {
              item.optom_dollar_price = response.data.optom_dollar_price;
              // item.optom_price = response.data.optom_dollar_price*self.datas.dollar_rate;
              item.optom_price = response.data.optom_price;
            item.optom_percent = self.calculateMarkupPercent(response.data.optom_dollar_price, item.debit_price);
            }
            if (response.data.chakana_dollar_price) {
              item.chakana_dollar_price = response.data.chakana_dollar_price;
              // item.chakana_price = response.data.chakana_dollar_price*self.dollar_rate;
              item.chakana_price = response.data.chakana_price;
              item.chakana_percent = self.calculateMarkupPercent(response.data.chakana_dollar_price, item.debit_price);
            }
          } else {
            item.current_balance = response.data.balance;
            if (response.data.price_type == 1) {
              item.kontragent_price = response.data.delivery_price;
              item.debit_price = response.data.delivery_price;
              item.pack_price = response.data.delivery_price*item.pack_price;
            } else if (response.data.price_type == 2) {
              item.kontragent_price = response.data.delivery_price*self.datas.dollar_rate;
              item.pack_price=item.pack_norma*response.data.delivery_price*self.datas.dollar_rate;
              item.debit_price = response.data.delivery_price*self.datas.dollar_rate;
              window.alert(
                self.$t("Bu tovar avval boshqa valutada kelgan")
              );
            }
            if (response.data.optom_dollar_price) {
              item.optom_dollar_price = response.data.optom_dollar_price;
              // item.optom_dollar_price = response.data.optom_price/self.datas.dollar_rate;
              item.optom_price = response.data.optom_price;
              item.optom_percent = self.calculateMarkupPercent(response.data.optom_price, item.debit_price);
            }
            if (response.data.chakana_dollar_price) {
              item.chakana_dollar_price = response.data.chakana_dollar_price;
              // item.chakana_dollar_price = response.data.chakana_price/self.dollar_rate;
              item.chakana_price = response.data.chakana_price;
              item.chakana_percent = self.calculateMarkupPercent(response.data.chakana_price, item.debit_price);
            }
          }
          setTimeout(() => {
            // self.Changeprice(index);
          }, 100);
        });
        // if (item.shtrix_kod == "") {
          axios({
            method: "get",
            url: "api/v1/product/id/" + item.product_id
          }).then(function (response) {
            item.pack_norma=response.data.pack_count;
            if (response.data.shtrix_table[0]) {
              item.shtrix_kod = response.data.shtrix_table[0].shtrix_kod;
            }
          });
        }
      },
      Focus() {
        if (this.$route.path == "/kirim/create") {
          this.$refs.focused.focus();
        } else {
          setTimeout(() => {
            $(".table-input")
              .eq(2)
              .focus();
          }, 100);

        }
      },
      Shtrix(index) {
        let self = this;
        var shtrix = self.datas.prixod_table[index].shtrix_kod;
        axios({
          method: "post",
          url: "api/v1/product/shtrix2/" + shtrix,
          data: { sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          console.log(response);
          if (!response.data[0]) {
          } else if (response.data[1]) {
            self.settedindex = index;
            self.shtrixlist = response.data;
            self.$bvModal.show("modal-shtrix");
          } else {
            self.datas.prixod_table[index].product_id =
              response.data[0].product_id;
            self.Productchange(index);
            var classs = $(":focus");
            var rrr = $("body")
              .find("input,select,textarea,button")
              .filter(":visible");
            var focused = rrr.eq(rrr.index(classs) + 2);
            focused.focus();
          }
        });
      },
      Selectproduct(index) {
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал" });
        window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      // Ta'minotchilar boshqaruv bo'limini yangi oynada ochish (faqat ta'minotchilar)
      OpenTaminotchiList() {
        if (this.changedisabled) return;
        let routeData = this.$router.resolve({ name: "Ta'minotchi" });
        window.open(routeData.href, "_blank", "width=1400, height=1000");
      },
      // Yangi ta'minotchi qo'shish sahifasini ochish (nomi oldindan to'ldiriladi)
      CreateTaminotchi(search) {
        if (this.changedisabled) return;
        localStorage.setItem("taminotchi_name", search || "");
        let routeData = this.$router.resolve({ name: "Taminotchi qoshish" });
        window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      // Ta'minotchi oynasidan qaytgach ro'yxatni yangilash (yangi qo'shilganini tanlash uchun)
      RefreshKontragents() {
        let self = this;
        axios.get("api/v1/kontragent").then(function (response) {
          self.kontragentlist = response.data;
        });
      },
      RasxodXisobPercent(){
        if(this.changedisabled==false){
        let self = this;
        if (self.datas.rasxod_summa != 0 && self.datas.summa) {
          var ortacharasxod = self.datas.rasxod_summa / self.datas.summa;
          self.datas.prixod_table.forEach(function (key, value) {
            key.debit_price =
              parseFloat(key.kontragent_price) +
              key.kontragent_price * ortacharasxod;
            key.debit_summa = key.debit_price * key.count;
              if (key.chakana_dollar_price > 0) {
                self.Changepercentchakana(value);
              }
              if (key.optom_dollar_price > 0) {
                self.Changepercentoptom(value);
              }
          });
        } else {
          self.datas.prixod_table.forEach(function (key, value) {
            key.debit_price = key.kontragent_price;
            key.debit_summa = key.debit_price * key.count;
              if (key.chakana_dollar_price > 0) {
                self.Changepercentchakana(value);
              }
              if (key.optom_dollar_price > 0) {
                self.Changepercentoptom(value);
              }
           });
        }
        self.Summa();
      }
      },
      // "Расход" maydoni / tugmasi: rasxodni tannarxga sochish (Summa oxirida applyRasxod ishlaydi)
      RasxodXisob() {
        if (this.changedisabled) return;
        this.Summa();
      },
      // Rasxod summasini har bir mahsulotga uning summasiga proporsional sochadi:
      //   tannarx = narx * (1 + rasxod / tovarlar jami summasi (so'mda))
      // Sotish foizi o'zgarmaydi — chakana/ulgurji narx yangi tannarxdan shu foiz bilan qayta hisoblanadi.
      // Rasxod 0 ga tushirilsa, tannarx ta'minotchi narxiga qaytadi.
      applyRasxod() {
        if (this.changedisabled || !this.datas || !Array.isArray(this.datas.prixod_table)) return;
        const self = this;
        const rasxod = this.toNum(this.datas.rasxod_summa);
        const summa = this.toNum(this.datas.summa);
        const ratio = rasxod > 0 && summa > 0 ? rasxod / summa : 0;
        let changed = false;

        this.datas.prixod_table.forEach(function (key, index) {
          const target = self.toNum(key.kontragent_price) * (1 + ratio);
          if (Math.abs(self.toNum(key.debit_price) - target) < 0.0005) return;
          key.debit_price = target;
          key.debit_summa = target * self.toNum(key.count);
          // Sotuv narxi bor bo'lsa — foizni saqlab, narxni yangi tannarxdan hisoblaymiz
          if (self.toNum(key.chakana_price) > 0 || self.toNum(key.chakana_dollar_price) > 0) self.Changepercentchakana(index);
          if (self.toNum(key.optom_price) > 0 || self.toNum(key.optom_dollar_price) > 0) self.Changepercentoptom(index);
          changed = true;
        });

        if (changed) {
          this.datas.prixod_summa = this.datas.prixod_table.reduce((a, key) => a + self.toNum(key.debit_summa), 0);
        }
      },
      // Qiymatni xavfsiz songa aylantirish (bo'sh / NaN / Infinity -> 0)
      toNum(v) {
        var n = parseFloat(String(v == null ? '' : v).replace(/\s/g, '').replace(',', '.'));
        return (isNaN(n) || !isFinite(n)) ? 0 : n;
      },
      getDollarRate() {
        return this.toNum(this.datas.dollar_rate) || 1;
      },
      isDollarItem(item) {
        return parseInt(item && item.price_type) === 2;
      },
      // Bir qator summalarini dona soni (count) va narxlardan qayta hisoblash
      Recalcsummas(item) {
        var count = this.toNum(item.count);
        item.kontragent_summa = this.toNum(item.kontragent_price) * count;
        item.debit_summa = this.toNum(item.debit_price) * count;
        item.optom_summa = this.toNum(item.optom_price) * count;
        item.chakana_summa = this.toNum(item.chakana_price) * count;
      },
      // Dona narxi (kontragent_price) kiritilganda — pachka narxi va summalar hisoblanadi
      Changeprice(index) {
        if (this.changedisabled) return;
        var item = this.datas.prixod_table[index];
        var norma = this.toNum(item.pack_norma);
        item.kontragent_price = this.toNum(item.kontragent_price);
        item.pack_price = norma > 0 ? item.kontragent_price * norma : 0;
        item.debit_price = item.kontragent_price;
        this.Recalcsummas(item);
        this.Summa();
      },
      // Pachka narxi (pack_price) kiritilganda — dona narxi va summalar hisoblanadi
      Changepackprice(index) {
        if (this.changedisabled) return;
        var item = this.datas.prixod_table[index];
        var norma = this.toNum(item.pack_norma);
        item.pack_price = this.toNum(item.pack_price);
        item.kontragent_price = norma > 0 ? item.pack_price / norma : item.pack_price;
        item.debit_price = item.kontragent_price;
        this.Recalcsummas(item);
        this.Summa();
      },
      // Dona soni (count) kiritilganda — pachka soni avtomatik hisoblanadi
      Changecount(index) {
        if (this.changedisabled) return;
        var item = this.datas.prixod_table[index];
        var norma = this.toNum(item.pack_norma);
        item.count = this.toNum(item.count);
        item.pack_count = norma > 0 ? item.count / norma : 0;
        this.Recalcsummas(item);
        this.Summa();
      },
      // Pachka soni (pack_count) kiritilganda — dona soni avtomatik hisoblanadi
      Changepack(index) {
        if (this.changedisabled) return;
        var item = this.datas.prixod_table[index];
        var norma = this.toNum(item.pack_norma);
        item.pack_count = this.toNum(item.pack_count);
        if (norma > 0) {
          item.count = item.pack_count * norma;
        }
        this.Recalcsummas(item);
        this.Summa();
      },
      // "1 пачкада" (pack_norma) kiritilganda — dona = pachka × norma, pachka narxi yangilanadi
      Changenorma(index) {
        if (this.changedisabled) return;
        var item = this.datas.prixod_table[index];
        var norma = this.toNum(item.pack_norma);
        item.pack_norma = norma;
        if (norma > 0) {
          item.count = this.toNum(item.pack_count) * norma;
          item.pack_price = this.toNum(item.kontragent_price) * norma;
        }
        this.Recalcsummas(item);
        this.Summa();
      },
      Changepercentoptom(index) {
        var item = this.datas.prixod_table[index];
        var percent = this.toNum(item.optom_percent);
        var rate = this.getDollarRate();
        if (this.isDollarItem(item)) {
          item.optom_dollar_price = this.toNum(item.debit_price) * (percent / 100 + 1);
          item.optom_price = item.optom_dollar_price * rate;
          item.optom_summa = item.optom_price * item.count;
        } else {
          item.optom_price = this.toNum(item.debit_price) * (percent / 100 + 1);
          item.optom_summa = item.optom_price * item.count;
          item.optom_dollar_price = item.optom_price / rate;
        }
      },
      Changepercentchakana(index) {
        var item = this.datas.prixod_table[index];
        var percent = this.toNum(item.chakana_percent);
        var rate = this.getDollarRate();
        if (this.isDollarItem(item)) {
          item.chakana_dollar_price = this.toNum(item.debit_price) * (percent / 100 + 1);
          item.chakana_price = item.chakana_dollar_price * rate;
          item.chakana_summa = item.chakana_price * item.count;
        } else {
          item.chakana_price = this.toNum(item.debit_price) * (percent / 100 + 1);
          item.chakana_summa = item.chakana_price * item.count;
          item.chakana_dollar_price = item.chakana_price / rate;
        }
      },
      Changepriceoptom(index) {
        var item = this.datas.prixod_table[index];
        if (item.debit_price > 0) {
          var rate = this.getDollarRate();
          if (this.isDollarItem(item)) {
            item.optom_dollar_price = item.optom_price / rate;
            item.optom_percent = this.calculateMarkupPercent(item.optom_dollar_price, item.debit_price);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_percent = this.calculateMarkupPercent(item.optom_price, item.debit_price);
            item.optom_summa = item.optom_price * item.count;
            item.optom_dollar_price = item.optom_price / rate;
          }
        }
      },
      Changepriceoptomdollar(index) {
        var item = this.datas.prixod_table[index];
        if (item.debit_price > 0) {
          var rate = this.getDollarRate();
          if (this.isDollarItem(item)) {
            item.optom_price = item.optom_dollar_price * rate;
            item.optom_percent = this.calculateMarkupPercent(item.optom_dollar_price, item.debit_price);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_price = item.optom_dollar_price * rate;
            item.optom_percent = this.calculateMarkupPercent(item.optom_price, item.debit_price);
            item.optom_summa = item.optom_price * item.count;
          }
        }
      },
      Changepricechakana(index) {
        var item = this.datas.prixod_table[index];
        if (item.debit_price > 0) {
          var rate = this.getDollarRate();
          if (this.isDollarItem(item)) {
            item.chakana_dollar_price = item.chakana_price / rate;
            item.chakana_percent = this.calculateMarkupPercent(item.chakana_dollar_price, item.debit_price);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_percent = this.calculateMarkupPercent(item.chakana_price, item.debit_price);
            item.chakana_summa = item.chakana_price * item.count;
            item.chakana_dollar_price = item.chakana_price / rate;
          }
        }
      },
      Changepricechakanadollar(index) {
        var item = this.datas.prixod_table[index];
        if (item.debit_price > 0) {
          var rate = this.getDollarRate();
          if (this.isDollarItem(item)) {
            item.chakana_price = item.chakana_dollar_price * rate;
            item.chakana_percent = this.calculateMarkupPercent(item.chakana_dollar_price, item.debit_price);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_price = item.chakana_dollar_price * rate;
            item.chakana_percent = this.calculateMarkupPercent(item.chakana_price, item.debit_price);
            item.chakana_summa = item.chakana_price * item.count;
          }
        }
      },
      calculateMarkupPercent(salePrice, costPrice) {
        const sale = this.toNum(salePrice);
        const cost = this.toNum(costPrice);
        if (cost <= 0) return 0;
        return Number(((sale - cost) / cost * 100).toFixed(2));
      },
      // Qiymatni yaxlitlash qadamiga moslash.
      //  'up'   — qat'iy yuqoriga keyingi qadamga (13 365 -> 14 000, 13 000 -> 14 000)
      //  'down' — qat'iy pastga oldingi qadamga (13 365 -> 13 000, 13 000 -> 12 000)
      //  'near' — eng yaqin qadamga (13 365 -> 13 000)
      RoundToStep(value, dir) {
        var step = this.toNum(this.roundStep);
        var v = this.toNum(value);
        if (step <= 0) return v;
        if (dir === 'up') return (Math.floor(v / step) + 1) * step;
        if (dir === 'down') {
          var d = (Math.ceil(v / step) - 1) * step;
          return d < 0 ? 0 : d;
        }
        return Math.round(v / step) * step; // near
      },
      // Chakana som narxini yaxlitlash + foiz/dollar/summani qayta hisoblash (tugma)
      RoundChakana(index, dir) {
        if (this.changedisabled) return;
        var item = this.datas.prixod_table[index];
        item.chakana_price = this.RoundToStep(item.chakana_price, dir);
        this.Changepricechakana(index);
      },
      // Ulgurji som narxini yaxlitlash + foiz/dollar/summani qayta hisoblash (tugma)
      RoundOptom(index, dir) {
        if (this.changedisabled) return;
        var item = this.datas.prixod_table[index];
        item.optom_price = this.RoundToStep(item.optom_price, dir);
        this.Changepriceoptom(index);
      },
      // Foiz kiritib bo'lingach (blur/change) chakana narxni eng yaqin qadamga avto-yaxlitlash
      AutoRoundChakana(index) {
        if (this.changedisabled || !this.autoRound) return;
        var item = this.datas.prixod_table[index];
        if (this.toNum(item.chakana_price) <= 0) return;
        item.chakana_price = this.RoundToStep(item.chakana_price, 'near');
        this.Changepricechakana(index);
      },
      // Foiz kiritib bo'lingach (blur/change) ulgurji narxni eng yaqin qadamga avto-yaxlitlash
      AutoRoundOptom(index) {
        if (this.changedisabled || !this.autoRound) return;
        var item = this.datas.prixod_table[index];
        if (this.toNum(item.optom_price) <= 0) return;
        item.optom_price = this.RoundToStep(item.optom_price, 'near');
        this.Changepriceoptom(index);
      },
      Addtable(type = 'default') {
        this.datas.prixod_table.push({
          product_id: 0,
          current_balance: 0,
          count: 0,
          debit_price: 0,
          debit_summa: 0,
          kontragent_price: 0,
          kontragent_summa: 0,
          chakana_percent: 0,
          optom_percent: 0,
          chakana_price: 0,
          chakana_dollar_price: 0,
          optom_price: 0,
          optom_dollar_price: 0,
          chakana_summa: 0,
          optom_summa: 0,
          shtrix_kod: "",
          pack_count:0,
          pack_price:0,
          pack_norma:0,
          price_type: parseInt(this.datas.pay_type_id) === 3 ? 2 : 1
        });
        if (type == 'default') {
          this.Tablefocus();
        }
      },
      Summa() {
        this.datas.summa = 0;
        this.datas.count_all = 0;
        this.datas.prixod_summa = 0;
        this.datas.summa_som = 0;
        this.datas.summa_dollar = 0;
        const rate = this.getDollarRate();
        let self = this;
        this.datas.prixod_table.forEach(function (key) {
          const itemSumma = self.toNum(key.kontragent_summa);
          const cnt = self.toNum(key.count);
          self.datas.count_all += cnt;
          self.datas.prixod_summa += self.toNum(key.debit_summa);
          if (self.isDollarItem(key)) {
            // Dollar item: kontragent_summa $ qiymatida
            self.datas.summa_dollar += itemSumma;
            // Umumiy `summa` so'm ekvivalenti (eski hisob-kitob uchun)
            self.datas.summa += itemSumma * rate;
          } else {
            self.datas.summa_som += itemSumma;
            self.datas.summa += itemSumma;
          }
        });
        // Narx/soni o'zgarsa rasxod ulushi ham o'zgaradi — darhol qayta sochamiz
        this.applyRasxod();
      },
      // Item valyutasini almashtirish (Sʼom ↔ Dollar)
      toggleItemCurrency(index) {
        if (this.changedisabled) return;
        const item = this.datas.prixod_table[index];
        if (!item) return;
        // 1 = Som (default), 2 = Dollar
        const newType = parseInt(item.price_type) === 2 ? 1 : 2;
        this.$set(item, 'price_type', newType);
        // Summa ni qayta hisoblash (kursga emas — qiymat asl, ammo jami valyuta'ga ta'sir qiladi)
        this.Summa();
      },
      Savedokument(type = "default") {
        let self = this;
        // if (self.rule.change == true) {
          if (self.sending == false) {
          // Soni kiritilgan-u, mahsulot tanlanmagan qator saqlanib ketmasin
          const badIndex = self.datas.prixod_table.findIndex(
            it => !(parseInt(it.product_id) > 0) && self.toNum(it.count) > 0);
          if (badIndex !== -1) {
            self.$store.state.errors = (badIndex + 1) + "-qatorda mahsulot tanlanmagan. Mahsulotni qaytadan tanlang.";
            return;
          }
          if (!self.datas.prixod_table.some(it => parseInt(it.product_id) > 0)) {
            self.$store.state.errors = "Kamida bitta mahsulot tanlang.";
            return;
          }
            self.sending=true;
          if (self.datas.rasxod_summa == "") {
            self.datas.rasxod_summa = 0;
          }
          if (this.$route.path == "/kirim/create") {
            var methods = "post";
            var action = "api/v1/prixod";
            self.Summa();
          } else {
            var methods = "patch";
            var action = "api/v1/prixod/id/" + self.$route.params.id;
            if (self.$store.state.saved == 1) {
              self.Summa();
              self.datas.updated_at = new Date()
                .valueOf()
                .toString()
                .slice(0, 10);
            }
          }
          // self.datas.created_at = new Date(self.datas.created_at)
          //   .valueOf()
          //   .toString()
          //   .slice(0, 10);
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            self.$store.state.saved = null;
            self.sending = false;
            if (type == "print") {
              let routeData = self.$router.resolve({
                name: "printprixod",
                query: { id: response.data.id }
              });
              let myWindow;
              myWindow = window.open(
                '#/kirim/print/' + response.data.id,
                "_blank",
                "width=1000, height=1000"
              );
              self.$router.push({ name: "Кирим" });
            } else if (type == "save") {
              self.$router.push({ path: "/kirim/update/" + response.data.id });
            } else if (type == 'barcode') {
              let myWindow;
              myWindow = window.open(
                '#/kirim/barcode/' + response.data.id,
                "_blank",
                "width=500, height=800"
              );
            } else if (type == 'a4') {
              localStorage.setItem("print_type", "Копия");
              let myWindow;
              myWindow = window.open(
                '#/kirim/a4print/' + response.data.id,
                "_blank",
                "width=500, height=800"
              );
              self.$router.push({ name: "Кирим" });
            }
            else {
              self.$router.push({ name: "Кирим" });
            }
          });
          if (self.sending == true) {
            setTimeout(() => {
              self.sending = false;
            }, 3000);
          }
        }
        // } else {
          // self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      }
    },
    computed: {
      filteredRows() {
        return this.shtrixlist.filter(row => {
          const name = row.extra_name.toString().toLowerCase();
          const searchTerm = this.filter.toLowerCase();

          return name.includes(searchTerm);
        });
      },
      // Prixod (kirim) uchun faqat ta'minotchilar ko'rsatiladi.
      // Mijoz = type 1; ta'minotchi = type 2 (Етказувчи), 3 (мижоз+ета.), 4 (yangi ta'minotchi).
      supplierlist() {
        return (this.kontragentlist || []).filter(item => parseInt(item.type) !== 1);
      }
    }
  };
</script>
<style>
  /* Kirim jadvali inputlarini kattalashtirish (faqat shu jadvalda) */
  #tableId .table-input {
    height: 38px !important;
    padding: 6px 8px !important;
    font-size: 15px !important;
    font-weight: 600;
  }
  #tableId .table-input:focus {
    border-color: #a142f4 !important;
    box-shadow: 0 0 0 2px rgba(161, 66, 244, 0.15);
  }

  /* Kartochka ko'rinishidagi inputlar (vue-numeric ichki input'iga ham yetadi) */
  .prod-card .table-input {
    width: 100%;
    height: 34px !important;
    padding: 6px 8px !important;
    font-size: 14px !important;
    font-weight: 600;
    text-align: right;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #f8fafc;
    outline: none;
    box-sizing: border-box;
  }
  .prod-card .table-input:focus {
    border-color: #a142f4 !important;
    background: #fff;
    box-shadow: 0 0 0 2px rgba(161, 66, 244, 0.15);
  }
  .prod-card .pc-bc {
    text-align: left;
    background: #fff;
  }
  /* Jami dona (natija) — ajratib ko'rsatiladi */
  .prod-card .pc-field-total .table-input {
    background: #fef9e7 !important;
    border-color: #f4d03f !important;
    font-weight: 800 !important;
    color: #b9770e !important;
  }
  /* Kartochka ichidagi v-select ixchamlashtirish */
  .prod-card .v-select .vs__dropdown-toggle {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-height: 38px;
    background: #fff;
  }
  .prod-card .v-select .vs__search { margin: 4px 0 0; }
  .prod-card .modallist {
    border: none;
    background: transparent;
    color: #94a3b8;
    cursor: pointer;
  }
  .prod-card .pluss {
    border: none;
    background: #f0e6ff;
    color: #a142f4;
    border-radius: 6px;
    font-weight: 800;
    padding: 0 8px;
    cursor: pointer;
  }
  .fiksa table {
  border-collapse: separate;
  border-spacing: 0;
  border-top: 1px solid grey;
}

.fiksa td,
.fiksa th {
  margin: 0;
  border: 1px solid grey;
  white-space: nowrap;
  border-top-width: 0px;
}

div.fiksa {
  width: calc(100% - 200px);
  overflow-x: scroll;
  margin-left: 200px;
  overflow-y: visible;
  padding: 0;
}

.fiksa .headcol {
  position: absolute;
  /* width: 5em; */
  left: 0;
  top: auto;
  border-top-width: 1px;
  /*only relevant for first row*/
  margin-top: -1px;
  /*compensate for top border*/
}

.fiksa .headcol:before {
  /* content: 'Row '; */
}

.fiksa .long {
  /* background: yellow; */
  letter-spacing: 1em;
}
</style>
<style scoped>
/* HEADER */
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: white;
  border-radius: 16px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
}
.form-header-left {
  display: flex;
  align-items: center;
}
.form-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.form-header-right label {
  font-weight: 700;
  color: #64748b;
  font-size: 13px;
}
.page-title {
  font-weight: 800;
  font-size: 20px;
  color: #2c3e50;
  margin: 0;
}
.back-circle-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #e0e6ed;
  background: white;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 12px;
  transition: 0.3s;
}
.back-circle-btn:hover {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
}
.change-btn {
  background: #f0e6ff;
  color: #a142f4;
  border: none;
  padding: 6px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  margin-left: 12px;
}
.change-btn:hover {
  background: #a142f4;
  color: white;
}
.kurs-input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 12px;
  width: 120px;
  font-weight: 600;
  text-align: center;
}
.kurs-input:focus {
  outline: none;
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

/* TOP FORM BAR */
.form-fields-bar {
  display: flex;
  gap: 10px;
  padding: 10px 15px;
  background: white;
  border-radius: 16px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
  flex-wrap: wrap;
  align-items: flex-end;
}
.field-item {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 100px;
}
.field-item label {
  font-size: 11px;
  font-weight: 700;
  color: #95a5a6;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
}
.field-item .input100,
.field-item input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 10px;
  font-weight: 600;
  font-size: 13px;
}
.field-item .input100:focus,
.field-item input:focus {
  outline: none;
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

/* TABLE SECTION (legacy) */
.table-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
  overflow-x: auto;
  overflow-y: hidden;
}

/* ============ CARD GRID ============ */
.cards-section {
  background: transparent;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.cards-totals {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 4px;
  flex-wrap: wrap;
}
.ct-pill {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 5px 14px;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.ct-pill small {
  font-size: 9px;
  color: #94a3b8;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.ct-pill b { font-size: 14px; color: #0f172a; white-space: nowrap; }
.ct-pill.blue b { color: #2563eb; }
.ct-count {
  margin-left: auto;
  font-size: 12px;
  font-weight: 700;
  color: #94a3b8;
}

/* Yuqoridagi "Mahsulot qo'shish" tugmasi (F1 ga teng) */
.add-product-top {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #a142f4 0%, #8b2de0 100%);
  color: #fff;
  border: none;
  height: 40px;
  padding: 0 18px;
  border-radius: 12px;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.2s;
}
.add-product-top:hover:not(:disabled) {
  filter: brightness(1.05);
  box-shadow: 0 6px 16px rgba(161, 66, 244, 0.35);
}
.add-product-top:disabled { opacity: 0.5; cursor: not-allowed; }
.add-product-top sup { font-size: 9px; opacity: 0.85; }

.cards-wrap {
  height: calc(100vh - 325px);
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 12px;
  padding: 4px;
  align-content: start;
}

.prod-card {
  background: white;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: box-shadow 0.15s, border-color 0.15s;
}
.prod-card:hover {
  border-color: #ddd6fe;
  box-shadow: 0 6px 18px rgba(161, 66, 244, 0.08);
}

.pc-head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.pc-index {
  background: #f0e6ff;
  color: #a142f4;
  font-weight: 800;
  font-size: 13px;
  min-width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pc-barcode {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 8px;
  color: #94a3b8;
}
.pc-barcode .pc-bc {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  flex: 1;
  height: 32px !important;
}
.pc-del {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #fff1f2;
  color: #e11d48;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: 0.15s;
}
.pc-del:hover { background: #e11d48; color: white; }

.pc-product { width: 100%; }
.pc-balance {
  font-size: 12px;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 4px 10px;
  align-self: flex-start;
}
.pc-balance b { color: #0f172a; }

.pc-group {
  border-top: 1px dashed #eef2f7;
  padding-top: 8px;
}
.pc-group-title {
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
}
.g-kolvo { background: #fde8e7; color: #c0392b; }
.g-kirim { background: #e9f3d8; color: #5d8a1f; }
.g-sena  { background: #dcf0f7; color: #1d7fa3; }

.pc-fields {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.pc-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin: 0;
}
.pc-field > span {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.pc-readonly {
  justify-content: center;
}
.pc-readonly b {
  font-size: 14px;
  color: #334155;
  text-align: right;
  font-weight: 700;
}
.pc-readonly b.blue { color: #2563eb; }
.pc-price-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pc-price-wrap .table-input { flex: 1; }

/* MIQDOR: tenglama ko'rinishi — Пачка сони × Пачкада = Жами дона */
.pc-qty {
  display: flex;
  align-items: flex-end;
  gap: 6px;
}
.pc-qty .pc-field { flex: 1; min-width: 0; }
.pc-op {
  font-weight: 800;
  font-size: 16px;
  color: #94a3b8;
  padding-bottom: 7px;
  flex-shrink: 0;
}

/* NARX: hisoblangan (read-only) qiymatlar stripi */
.pc-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.pcs-item {
  flex: 1;
  min-width: 90px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  padding: 5px 8px;
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}
.pcs-item span {
  font-size: 9px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.pcs-item b {
  font-size: 13px;
  color: #334155;
  font-weight: 800;
}
.pcs-item b.blue { color: #2563eb; }

/* SOTUV: ikki ustun (Чакана / Улгуржи) */
.pc-sell {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.pc-sell-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #fafbfc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  padding: 8px;
}
.pc-sell-head {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  text-align: center;
  padding: 3px 0;
  border-radius: 6px;
}
.chakana-h { background: #dbeafe; color: #1d4ed8; }
.optom-h   { background: #ede9fe; color: #6d28d9; }

/* TEZ MAHSULOT QO'SHISH MODALI */
.quick-form { padding: 4px 2px; }
.qf-full { margin-bottom: 14px; }
.qf-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 4px;
}
.qf-req { color: #e11d48; }
.qf-field { margin-bottom: 14px; }
.qf-grid .qf-field { margin-bottom: 0; }
.qf-select { background: #fff; }
.qf-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 5px;
}
.qf-input {
  width: 100%;
  height: 42px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 15px;
  font-weight: 600;
  outline: none;
}
.qf-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.12);
}
.qf-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #94a3b8;
  background: #f8fafc;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 16px;
}
.qf-actions {
  display: flex;
  gap: 10px;
}
.qf-cancel, .qf-save {
  flex: 1;
  height: 42px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  border: none;
}
.qf-cancel { background: #f1f5f9; color: #64748b; }
.qf-cancel:hover { background: #e2e8f0; }
.qf-save { background: #16a34a; color: #fff; }
.qf-save:hover:not(:disabled) { background: #15803d; }
.qf-save:disabled { opacity: 0.6; cursor: not-allowed; }

/* Sotuv narxini yaxlitlash: input + ▲/▼ tugmalar */
.pc-round-wrap {
  display: flex;
  align-items: stretch;
  gap: 4px;
}
.pc-round-wrap .table-input { flex: 1; }
.round-btns {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 24px;
  flex-shrink: 0;
}
.round-btn {
  flex: 1;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  border-radius: 6px;
  font-size: 9px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  transition: 0.15s;
}
.round-btn:hover:not(:disabled) {
  background: #a142f4;
  color: #fff;
  border-color: #a142f4;
}
.round-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* Footer: yaxlitlash sozlamalari */
.round-settings {
  display: flex;
  align-items: center;
  gap: 12px;
}
.round-settings .rs-check,
.round-settings .rs-step {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
  margin: 0;
}
.rs-step-input {
  width: 80px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 8px;
  font-weight: 600;
  font-size: 13px;
}
.rs-step-input:focus {
  outline: none;
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

.cards-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px 10px;
  color: #94a3b8;
  font-size: 14px;
  background: white;
  border: 1px dashed #e2e8f0;
  border-radius: 14px;
}

@media (max-width: 768px) {
  .cards-wrap {
    grid-template-columns: 1fr;
    height: auto;
    max-height: none;
  }
}

/* Per-item currency toggle */
.cur-toggle {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 800;
  padding: 3px 8px;
  cursor: pointer;
  flex-shrink: 0;
  transition: 0.15s;
  min-width: 38px;
}
.cur-toggle:hover { background: #e2e8f0; }
.cur-toggle.cur-dollar {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border-color: #10b981;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3);
}
.cur-toggle:disabled { opacity: 0.5; cursor: not-allowed; }

/* Currency totals in footer */
.cur-totals {
  display: flex;
  gap: 8px;
  margin-right: auto;
  flex-wrap: wrap;
}
.cur-total-pill {
  background: white;
  border-radius: 10px;
  padding: 5px 12px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.cur-total-pill small {
  font-size: 9px;
  color: #94a3b8;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.cur-total-pill b {
  font-size: 13px;
  color: #0f172a;
  white-space: nowrap;
}
.cur-total-pill.som b { color: #2563eb; }
.cur-total-pill.dollar { background: #f0fdf4; border-color: #a7f3d0; }
.cur-total-pill.dollar b { color: #16a34a; }
.cur-total-pill.total { background: #faf5ff; border-color: #ddd6fe; }
.cur-total-pill.total b { color: #a142f4; font-weight: 800; }

/* FOOTER */
.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: white;
  border-radius: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
  gap: 8px;
  flex-wrap: wrap;
  position: sticky;
  bottom: 0;
  z-index: 10;
}
.form-footer span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.footer-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  height: 38px;
  padding: 0 14px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
  white-space: nowrap;
}
.footer-btn:hover:not(:disabled) {
  border-color: #a142f4;
  color: #a142f4;
}
.footer-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.add-row-btn {
  background: #f0e6ff;
  color: #a142f4;
  border-color: #f0e6ff;
}
.add-row-btn:hover:not(:disabled) {
  background: #a142f4;
  color: white;
}
.btn-save {
  background: #16a34a;
  color: white;
  border: none;
  padding: 8px 20px;
  height: 38px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.btn-save:hover:not(:disabled) {
  background: #15803d;
}
.btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-save-close {
  background: #a142f4;
  color: white;
  border: none;
  padding: 8px 20px;
  height: 38px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.btn-save-close:hover:not(:disabled) {
  background: #8b2de0;
  box-shadow: 0 4px 16px rgba(161, 66, 244, 0.35);
}
.btn-save-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* MODAL */
.modal-table-wrapper {
  padding: 10px;
}
.modal-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
}
.modal-table thead th {
  background: #f8fafc;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 13px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid #e2e8f0;
}
.modal-table tbody td {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}
.modal-table tbody tr:hover {
  background: #f8fafc;
}
.search-wrapper {
  margin-bottom: 12px;
}
.search-wrapper input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  width: 100%;
}
.search-wrapper input:focus {
  outline: none;
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

/* RESPONSIVE */
@media (max-width: 1200px) {
  .form-fields-bar {
    gap: 8px;
  }
  .field-item {
    min-width: 130px;
  }
}

@media (max-width: 768px) {
  .form-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    padding: 10px 15px;
  }
  .form-fields-bar {
    flex-direction: column;
    padding: 10px;
  }
  .field-item {
    width: 100%;
    min-width: unset;
  }
  .form-footer {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    position: static;
  }
  .form-footer > div {
    flex-wrap: wrap;
    justify-content: center;
  }
  .form-footer span {
    justify-content: center;
  }
}
</style>
